import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {detecteSegmentoPorTexto, SEGMENTOS_DISPONIVEIS} from '../../segment-templates';
import {CaminhoEntrada} from '../../wizard-state.model';
import {FotoService} from '../../../../services/foto.service';

@Component({
  selector: 'app-step-boas-vindas',
  templateUrl: './step-boas-vindas.component.html',
  styleUrls: ['./step-boas-vindas.component.scss']
})
export class StepBoasVindasComponent implements OnInit {
  @Input() nomeInicial = '';
  @Input() segmentoInicial: string | null = null;
  @Input() caminhoEscolhido: CaminhoEntrada | null = null;
  @Input() empresa: any = {};
  @Input() logoAtual: string | null = null;
  @Output() onVoltar = new EventEmitter<void>();
  @Output() onConcluido = new EventEmitter<{nome: string; segmento: string | null; logoUrl: string | null}>();

  nome = '';
  segmentoSelecionado: string | null = null;
  segmentos = SEGMENTOS_DISPONIVEIS;
  erroValidacao: string | null = null;
  shakeNome = false;
  shakeSegmento = false;
  logoSalvo: string | null = null;
  abrirUpload = false;
  dialogState: 'preview' | 'upload' = 'preview';
  empresaParaUpload: any = {};
  private segmentoFoiEscolhidoManualmente = false;

  constructor(private fotoService: FotoService) {}

  ngOnInit() {
    this.nome = this.nomeInicial;
    this.segmentoSelecionado = this.segmentoInicial;
    this.logoSalvo = this.logoAtual;
    this.segmentoFoiEscolhidoManualmente = !!this.segmentoInicial;
    this.atualizeSegmentoPeloNome();
  }

  get logoPreview(): string | null {
    return this.logoSalvo || this.empresa?.logo || null;
  }

  get iniciais(): string {
    return (this.nome || this.nomeInicial || '')
      .split(' ')
      .filter(p => p.length > 0)
      .slice(0, 2)
      .map(p => p[0].toUpperCase())
      .join('');
  }

  selecioneSegmento(segmento: string) {
    this.segmentoFoiEscolhidoManualmente = true;
    this.segmentoSelecionado = segmento;
  }

  onNomeChange() {
    this.atualizeSegmentoPeloNome();
  }

  classeCorSegmento(segmento: string): string {
    return `segmento-cor-${this.normalizeSegmento(segmento)}`;
  }

  podeAvancar(): boolean {
    if (!this.nome.trim().length) return false;
    if (this.segmentoObrigatorio) return this.segmentoSelecionado != null;
    return true;
  }

  get segmentoObrigatorio(): boolean {
    return this.caminhoEscolhido === 'template';
  }

  get titulo(): string {
    return this.caminhoEscolhido === 'importar'
      ? 'Confira os dados da sua loja'
      : 'Vamos configurar sua loja!';
  }

  get subtitulo(): string {
    if (this.caminhoEscolhido === 'importar') {
      return 'Se encontrarmos dados no sistema antigo, já deixamos tudo pré-preenchido para você revisar.';
    }

    return 'Comece com o nome e o tipo do seu negócio.';
  }

  abrirDialogFoto() {
    this.empresaParaUpload = {...this.empresa, logo: null};
    this.dialogState = this.logoPreview ? 'preview' : 'upload';
    this.abrirUpload = true;
  }

  fecharDialogFoto() {
    this.abrirUpload = false;
    this.dialogState = 'preview';
  }

  entrarModoUpload() {
    this.empresaParaUpload = {...this.empresa, logo: null};
    this.dialogState = 'upload';
  }

  removerFoto() {
    this.empresa.logo = null;
    this.logoSalvo = null;
    this.fecharDialogFoto();
  }

  salveLogoEmpresa($event: any) {
    this.empresa.logo = this.empresaParaUpload.logo;
    this.fotoService.salveLogoEmpresa(this.empresa).then(() => {
      $event.salvou();
      this.logoSalvo = this.empresa.logo;
      this.fecharDialogFoto();
    }).catch(err => {
      $event.erro(err);
    });
  }

  avancar() {
    if (!this.nome.trim()) {
      this.erroValidacao = 'Informe o nome da sua loja.';
      this.shakeNome = true;
      setTimeout(() => this.shakeNome = false, 600);
      return;
    }
    if (this.segmentoObrigatorio && !this.segmentoSelecionado) {
      this.erroValidacao = 'Selecione o segmento do negócio.';
      this.shakeSegmento = true;
      setTimeout(() => this.shakeSegmento = false, 600);
      return;
    }
    this.erroValidacao = null;
    this.onConcluido.emit({
      nome: this.nome.trim(),
      segmento: this.segmentoSelecionado,
      logoUrl: this.logoPreview
    });
  }

  private normalizeSegmento(segmento: string): string {
    return (segmento || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  private atualizeSegmentoPeloNome() {
    if (this.segmentoFoiEscolhidoManualmente) return;

    const segmentoDetectado = detecteSegmentoPorTexto(this.nome);
    const segmentoDisponivel = this.segmentos.find(seg => seg.nome === segmentoDetectado);

    this.segmentoSelecionado = segmentoDisponivel ? segmentoDisponivel.nome : null;
  }
}
